import { Button } from "reactstrap";
import useModal from "../../../customHooks/useModal";
import useSWR from "swr";
import { customFetcher, getTsDate, notify } from "../../../utils";
import apiClient from "../../../apiClient";
import { useState } from "react";
import useUser from "../../../customHooks/useUser";
import { AircraftType } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import AircraftTypesModal from "./Modal";
import ActionIcon from "../../../components/custom/ActionIcon";

const ENDPOINT = '/aircraft-type';

export default function AircraftTypes () {

    const { user } = useUser();
    const { data, mutate } = useSWR(ENDPOINT, customFetcher<AircraftType>, {
        fallbackData: []
    });

    const [id, setId] = useState<number>();
    const record = data.find(item => item.id === id);

    const createUpdateItem = async (data: AircraftType, update?: boolean) => {
        try {
            const method = update ? 'put' : 'post';
            await apiClient[method](ENDPOINT, data);
            mutate();
            setModal(false);
            notify('Success');
        } catch (err) {
            alert(err);
        }
    }

    const deleteItem = async (id: number) => {
        try {
            await apiClient.delete(`${ENDPOINT}/${id}`);
            setModal(false);
            notify('Deleted');
            mutate();
        } catch (err) {
            alert(err);
        }
    }

    const { modal, setModal } = useModal();
    
    const handleLaunchModal = (id?: number) => {
        setId(id || undefined);
        setModal(true);
    }

    return (
        <div>
            <ActionIcon 
                type={'add'}
                onClick={handleLaunchModal}
            />
            <VirtualTable<AircraftType> 
                data={data}
                mapping={[{
                    name: 'FAA_Designator',
                    value: 'FAA_Designator'
                }, {
                    name: 'Manufacturer',
                    value: 'Manufacturer'
                }, {
                    name: 'Model_FAA',
                    value: 'Model_FAA'
                }, {
                    name: 'Model_BADA',
                    value: 'Model_BADA'
                }, {
                    name: 'Physical_Class_Engine',
                    value: 'Physical_Class_Engine'
                }, {
                    name: 'Num_Engines',
                    value: 'Num_Engines',
                    number: true,
                    smallWidth: true
                }, {
                    name: 'MTOW',
                    value: 'MTOW'
                }, {
                    name: 'MALW',
                    value: 'MALW'
                }, {
                    name: 'ICAO_WTC',
                    value: 'ICAO_WTC'
                }, {
                    name: 'Class',
                    value: 'Class'
                }, {
                    name: 'FAA_Weight',
                    value: 'FAA_Weight'
                }]}
                handleClick={item => handleLaunchModal(item.id)}
            />
            <AircraftTypesModal 
                modal={modal}
                setModal={setModal}
                onSubmit={createUpdateItem}
                deleteItem={deleteItem}
                record={record}
            />
        </div>
    );
}